/* eslint react/no-multi-comp: 0 */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import {get} from 'lodash';
import MediaQuery from '../common/media_query';
import Product from '../../components/article/products/product';
import { sendAnalyticsEvent, sendDataLayerEvent } from '../../utils/analytics';
import { getBoundingClientRect } from '../../utils/dom';

// 1/3 of the 720px container plus an extra 10px to account for margins
const THIRD_WIDTH = 250;

export default function MultiProductSection({ content: { products }, hide_product_info_button }) {
  return (
    <div className="section-multi-product-container">
      <MediaQuery breakpoint="mobile">
        <MultiProductCarousel
          products={products}
          isScrollable
          hide_product_info_button={hide_product_info_button}
        />
      </MediaQuery>
      <MediaQuery breakpoint="tablet">
        <MultiProductCarousel
          products={products}
          isScrollable
          hide_product_info_button={hide_product_info_button}
        />
      </MediaQuery>
      <MediaQuery breakpoint="desktop">
        <MultiProductCarousel
          products={products}
          showArrows={products.length > 3}
          hide_product_info_button={hide_product_info_button}
        />
      </MediaQuery>
    </div>
  );
}

MultiProductSection.propTypes = {
  content: PropTypes.shape({
    products: PropTypes.arrayOf(PropTypes.object).isRequired
  }),
  hide_product_info_button: PropTypes.bool
};

export class MultiProductCarousel extends PureComponent {
  state = {
    left: 0,
    maxLeft: (this.props.products.length * THIRD_WIDTH - (THIRD_WIDTH * 3)) * -1,
    leftTrackingBoundary: 0,
    rightTrackingBoundary: 0
  };

  componentDidMount() {
    const {
      left: leftTrackingBoundary,
      right: rightTrackingBoundary
    } = getBoundingClientRect(this._node);
    this.setState({ leftTrackingBoundary, rightTrackingBoundary });
  }

  handleClickArrow = (direction) => {
    const { maxLeft, left } = this.state;

    if (direction === 'left' && left !== 0) {
      this.setState({
        left: left + THIRD_WIDTH
      });
    } else if (direction === 'right' && left > maxLeft) {
      this.setState({
        left: left - THIRD_WIDTH
      });
    }

    sendAnalyticsEvent(
      'Products As Assets Carousel',
      'Click',
      `${direction}-arrow`
    );

    const actionTypeDirection = direction.charAt(0).toUpperCase() + direction.slice(1);

    sendDataLayerEvent('Click', {
      pageModule: 'Main content',
      linkType: 'product carousel',
      actionType: `${actionTypeDirection} click`
    });
  };

  render() {
    const { products, showArrows, isScrollable, hide_product_info_button } = this.props;
    const { left, maxLeft, leftTrackingBoundary, rightTrackingBoundary } = this.state;
    const productCount = products.length;
    const showProductCount = showArrows || (isScrollable && productCount > 1);

    return (
      <div className={classNames('multi-product-carousel-container', showArrows && 'with-arrows')} ref={node => this._node = node}>
        {showProductCount &&
          <div className="product-count">
            {`shop ${productCount} products`}
          </div>
        }
        {showArrows &&
          <span
            className={classNames('left-arrow', left === 0 && 'disabled')}
            onClick={() => this.handleClickArrow('left')}
          />
        }
        <div
          style={{ transform: `translateX(${left}px)` }}
          className={classNames('products-row', products.length > 2 && 'increase-spread', products.length === 1 && 'single-product', isScrollable && 'scrollable')}
        >
          {products.map((product, data_index) =>
            <Product
              {...product}
              key={product.id}
              data_index={data_index}
              hide_product_info_button={hide_product_info_button}
              leftTrackingBoundary={get(product, 'leftTrackingBoundary', leftTrackingBoundary)}
              rightTrackingBoundary={get(product, 'rightTrackingBoundary', rightTrackingBoundary)}
            />
          )}
        </div>
        {showArrows &&
          <span
            className={classNames('right-arrow', left === maxLeft && 'disabled')}
            onClick={() => this.handleClickArrow('right')}
          />
        }
      </div>
    );
  }
}

MultiProductCarousel.propTypes = {
  products: PropTypes.arrayOf(PropTypes.object).isRequired,
  showArrows: PropTypes.bool,
  isScrollable: PropTypes.bool,
  hide_product_info_button: PropTypes.bool
};
